export const AID_STUDIO_STEPS = [
  { value: 'basic-info', label: 'Basic information', isDisabled: false },
  { value: 'funds', label: 'Funds', isDisabled: false },
  { value: 'tuition', label: 'Tuition & CoA', isDisabled: false },
  { value: 'matrix', label: 'Awarding regimes', isDisabled: false },
  { value: 'exceptions', label: 'Exceptions', isDisabled: true },
  { value: 'results', label: 'Results', isDisabled: true },
];

export const ENROLLMENT_TYPES = [
  { value: 'FIRST_YEAR', label: 'First year' },
  { value: 'TRANSFER', label: 'Transfer' },
];

export const DATASET_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
};

export const DEFAULT_ENTRY_TERM = [{ value: 2026, label: '2026' }];
